var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { width: "265px", opacity: "0" },
      attrs: { id: "mdPrintId" }
    },
    [
      _c(
        "el-row",
        [
          _vm.printData.length > 0
            ? _c(
                "el-col",
                _vm._l(_vm.printData, function(list) {
                  return _c(
                    "div",
                    {
                      key: list,
                      staticStyle: { "page-break-after": "always" }
                    },
                    [
                      list.space || list.position
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "border-bottom": "1px solid",
                                "margin-bottom": "0",
                                padding: "10px 0",
                                "font-size": "24px",
                                "font-weight": "800",
                                width: "100%"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "60%",
                                    display: "inline-block"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(list.space) +
                                      " \n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    width: "36%",
                                    display: "inline-block"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(list.position) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-bottom": "0", width: "100%" }
                        },
                        [
                          _c("div", { staticStyle: { "font-size": "24px" } }, [
                            _vm._v(_vm._s(list.consignee))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                "margin-top": "4px"
                              }
                            },
                            [
                              _vm._v(
                                "\n            收货地址：" +
                                  _vm._s(list.address) +
                                  "\n          "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { border: "0.5px solid", width: "100%" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-bottom": "0", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              width: "265px",
                              "margin-top": "20px",
                              "margin-bottom": "10px"
                            },
                            attrs: {
                              src:
                                "https://erp.yishouapp.com/barcode.php?text=" +
                                list.wave_picking_no
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "font-weight": "bold"
                          }
                        },
                        [
                          _vm._v(
                            "\n          快递公司:" +
                              _vm._s(list.shipping_company) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          border: "0.5px solid",
                          width: "100%",
                          "font-size": "20px",
                          "padding-top": "0px"
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(list.goods_info, function(goods) {
                        return _c(
                          "div",
                          {
                            key: goods,
                            staticStyle: { "margin-bottom": "0", width: "100%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "24px",
                                  "margin-top": "5px",
                                  "margin-bottom": "5px",
                                  "font-weight": "bold"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "normal" } },
                                  [_vm._v(_vm._s(goods.goods_no))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { float: "right" } },
                                  [_vm._v(_vm._s(goods.goods_location))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "22px",
                                  "margin-top": "5px",
                                  "margin-bottom": "5px",
                                  "font-weight": "bold"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      float: "left",
                                      border: "black solid 1px",
                                      "border-radius": "100%",
                                      padding: "0px 4px"
                                    }
                                  },
                                  [_vm._v(_vm._s(goods.no))]
                                ),
                                _vm._v(" "),
                                _vm._l(goods.sku, function(sku) {
                                  return _c("div", { key: sku }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          float: "right"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(sku) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { clear: "both" }
                                    })
                                  ])
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "margin-top": "5px",
                                  "margin-bottom": "5px"
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(goods.goods_name))])]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticStyle: {
                                border: "1px dotted",
                                width: "100%"
                              }
                            })
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-bottom": "0", width: "100%" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "24px",
                                "text-align": "center",
                                "margin-top": "5px",
                                "margin-bottom": "5px"
                              }
                            },
                            [
                              _vm._v(
                                "\n            共" +
                                  _vm._s(list.spu_num) +
                                  "款，" +
                                  _vm._s(list.sku_num) +
                                  "件\n          "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          border: "2px dotted",
                          width: "100%",
                          "margin-bottom": "20px"
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(list.order_info, function(order) {
                        return _c(
                          "div",
                          {
                            key: order,
                            staticStyle: { "margin-bottom": "0", width: "100%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "margin-top": "5px",
                                  "margin-bottom": "5px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      border: "black solid 1px",
                                      "border-radius": "100%",
                                      padding: "0px 4px"
                                    }
                                  },
                                  [_vm._v(_vm._s(order.order_no))]
                                ),
                                _vm._v(" "),
                                _vm.type == 4
                                  ? _c("span", [
                                      _vm._v("工单id：" + _vm._s(order.work_id))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.type != 4
                                  ? _c("span", [
                                      _vm._v(
                                        "订单号：" + _vm._s(order.order_sn)
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                order.problem_name && _vm.type >= 4
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "18px",
                                          "font-weight": "bold"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              工单问题：" +
                                            _vm._s(order.problem_name) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                order.problem_desc && _vm.type >= 4
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "18px",
                                          "font-weight": "bold"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              工单描述：" +
                                            _vm._s(order.problem_desc) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { border: "0.5px solid", width: "100%" }
                      })
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6310220c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6310220c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LodopPrintForCheck.vue
// module id = null
// module chunks = 